<template>
  <el-form-item
    v-if="widget.options.visible"
    :label="widget.options.showName ? widget.name : ''"
    :label-width="!widget.options.showName ? '0px' : null"
    :prop="widget.model"
  >
    <template v-if="widget.type == 'input'">
      <el-input
        v-if="widget.options.dataType == 'number' || widget.options.dataType == 'integer' || widget.options.dataType == 'float'"
        v-model.number="dataModel"
        type="number"
        :placeholder="widget.options.placeholder"
        :style="{width: widget.options.width}"
        :disabled="!widget.options.editable"
      />
      <el-input
        v-else
        v-model="dataModel"
        :type="widget.options.dataType"
        :disabled="!widget.options.editable"
        :placeholder="widget.options.placeholder"
        :style="{width: widget.options.width}"
      />
    </template>

    <template v-if="widget.type == 'textarea'">
      <el-input
        v-model="dataModel" type="textarea"
        :rows="5"
        :disabled="widget.options.disabled"
        :placeholder="widget.options.placeholder"
        :style="{width: widget.options.width}"
      />
    </template>

    <template v-if="widget.type == 'number'">
      <el-input-number
        v-model="dataModel"
        :style="{width: widget.options.width}"
        :step="widget.options.step"
        controls-position="right"
        :disabled="widget.options.disabled"
        :min="widget.options.min"
        :max="widget.options.max"
      />
    </template>

    <template v-if="widget.type == 'radio'">
      <el-radio-group
        v-model="dataModel"
        :style="{width: widget.options.width}"
        :disabled="widget.options.disabled"
      >
        <el-radio
          v-for="(item, index) in (widget.options.remote ? widget.options.remoteOptions : widget.options.options)"
          :key="index" :style="{display: widget.options.inline ? 'inline-block' : 'block'}" :label="item.value"
        >
          <template v-if="widget.options.remote">{{ item.label }}</template>
          <template v-else>{{ widget.options.showLabel ? item.label : item.value }}</template>
        </el-radio>
      </el-radio-group>
    </template>

    <template v-if="widget.type == 'checkbox'">
      <el-checkbox-group
        v-model="dataModel"
        :style="{width: widget.options.width}"
        :disabled="widget.options.disabled"
      >
        <el-checkbox

          v-for="(item, index) in (widget.options.remote ? widget.options.remoteOptions : widget.options.options)"
          :key="index" :style="{display: widget.options.inline ? 'inline-block' : 'block'}" :label="item.value"
        >
          <template v-if="widget.options.remote">{{ item.label }}</template>
          <template v-else>{{ widget.options.showLabel ? item.label : item.value }}</template>
        </el-checkbox>
      </el-checkbox-group>
    </template>

    <template v-if="widget.type == 'time'">
      <el-time-picker
        v-model="dataModel"
        :is-range="widget.options.isRange"
        :placeholder="widget.options.placeholder"
        :start-placeholder="widget.options.startPlaceholder"
        :end-placeholder="widget.options.endPlaceholder"
        :readonly="widget.options.readonly"
        :disabled="widget.options.disabled"
        :editable="widget.options.editable"
        :clearable="widget.options.clearable"
        :arrow-control="widget.options.arrowControl"
        :value-format="widget.options.format"
        :style="{width: widget.options.width}"
      />
    </template>

    <template v-if="widget.type=='date'">
      <el-date-picker
        v-model="dataModel"
        :type="widget.options.type"
        :placeholder="widget.options.placeholder"
        :start-placeholder="widget.options.startPlaceholder"
        :end-placeholder="widget.options.endPlaceholder"
        :readonly="widget.options.readonly"
        :disabled="widget.options.disabled"
        :editable="widget.options.editable"
        :clearable="widget.options.clearable"
        :value-format="widget.options.timestamp ? 'timestamp' : widget.options.format"
        :format="widget.options.format"
        :style="{width: widget.options.width}"
      />
    </template>

    <template v-if="widget.type =='rate'">
      <el-rate
        v-model="dataModel"
        :max="widget.options.max"
        :disabled="widget.options.disabled"
        :allow-half="widget.options.allowHalf"
      />
    </template>

    <template v-if="widget.type == 'color'">
      <el-color-picker
        v-model="dataModel"
        :disabled="widget.options.disabled"
        :show-alpha="widget.options.showAlpha"
      />
    </template>

    <template v-if="widget.type == 'select'">
      <el-select
        v-model="dataModel"
        :disabled="widget.options.disabled"
        :multiple="widget.options.multiple"
        :clearable="widget.options.clearable"
        :placeholder="widget.options.placeholder"
        :style="{width: widget.options.width}"
        :filterable="widget.options.filterable"
      >
        <el-option v-for="item in (widget.options.remote ? widget.options.remoteOptions : widget.options.options)" :key="item.value" :value="item.value" :label="widget.options.showLabel || widget.options.remote?item.label:item.value" />
      </el-select>
    </template>

    <template v-if="widget.type=='switch'">
      <el-switch
        v-model="dataModel"
        :disabled="widget.options.disabled"
      />
    </template>

    <template v-if="widget.type=='slider'">
      <el-slider
        v-model="dataModel"
        :min="widget.options.min"
        :max="widget.options.max"
        :disabled="widget.options.disabled"
        :step="widget.options.step"
        :show-input="widget.options.showInput"
        :range="widget.options.range"
        :style="{width: widget.options.width}"
      />
    </template>

    <template v-if="widget.type=='imgupload'">
      <fm-upload
        v-model="dataModel"
        :disabled="widget.options.disabled"
        :style="{'width': widget.options.width}"
        :width="widget.options.size.width"
        :height="widget.options.size.height"
        :token="widget.options.token"
        :domain="widget.options.domain"
        :multiple="widget.options.multiple"
        :length="widget.options.length"
        :is-qiniu="widget.options.isQiniu"
        :is-delete="widget.options.isDelete"
        :min="widget.options.min"
        :is-edit="widget.options.isEdit"
        :action="widget.options.action"
      />
    </template>

    <template v-if="widget.type == 'editor'">
      <vue-editor
        v-model="dataModel"
        :style="{width: widget.options.width}"
      />
    </template>

    <template v-if="widget.type == 'cascader'">
      <el-cascader
        v-model="dataModel"
        :disabled="widget.options.disabled"
        :clearable="widget.options.clearable"
        :placeholder="widget.options.placeholder"
        :style="{width: widget.options.width}"
        :options="widget.options.remoteOptions"
      />
    </template>

    <template v-if="widget.type == 'text'">
      <span>{{ dataModel }}</span>
    </template>
    <template v-if="widget.type==='dept'">
      <member-list-pane v-model="dataModel" :data="memberListPaneData" height="45px" :readonly="!widget.options.editable" modal-append-to-body :style="{width: widget.options.width}" single :tabs="['department']" />
    </template>
    <template v-if="widget.type==='user'">
      <member-list-pane v-model="dataModel" :data="memberListPaneData" height="45px" :readonly="!widget.options.editable" modal-append-to-body :style="{width: widget.options.width}" single :tabs="['user']" />
    </template>
    <template v-if="widget.type === 'upload'">
      <el-upload
        :on-success="handleUploadSuccess"
        :on-remove="handleUploadRemove"
        :before-upload="beforeUpload"
        drag
        multiple
        action="/upload"
        :file-list="fileList"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </template>
    <template v-if="widget.type === 'divider'">
      <el-divider content-position="left"><span class="text-base">{{ widget.name }}</span></el-divider>
    </template>
  </el-form-item>
</template>

<script>
import FmUpload from './Upload'
import MemberListPane from '../MemberListPane'
import {debounce} from 'lodash/function'

export default {
  components: {
    MemberListPane,
    FmUpload,
  },
  props: ['widget', 'models', 'rules', 'remote', 'authMember'],
  data () {
    return {
      fileList: [],
      dataModel: this.models[this.widget.model],
      memberListPaneData: {},
    }
  },
  watch: {
    dataModel: {
      immediate: true,
      deep: true,
      handler (val) {
        console.log('watch dataModel', val, this.widget)
        this.models[this.widget.model] = val
        this.$emit('update:models', {
          ...this.models,
          [this.widget.model]: val,
        })
        this.$emit('input-change', val, this.widget.key)
      },
    },
    fileList: {
      deep: true,
      handler(val) {
        console.log('watch fileList', val)
        var res = []
        val.map(item => {
          if (!Object.keys(item).includes('response')) {
            return
          }
          res.push({
            name: item.response.name,
            id: item.response.id,
          })
        })
        this.dataModel = res
      },
    },
    models: {
      deep: true,
      handler (val) {

        this.dataModel = val[this.widget.model]
        // console.log('GenerateFormItem', this.dataModel)
      },
    },
  },
  created () {
    if (this.widget.type === 'user') {
      if (this.widget.options.defaultValue) {
        this.memberListPaneData = [{id: this.authMember.member.id, name: this.authMember.member.name, type: 'user'}]

      } else {
        this.memberListPaneData = []
      }
    } else if (this.widget.type === 'dept') {
      if (this.widget.options.defaultValue === 'dynamic_current_dept') {
        this.memberListPaneData = [{
          id: this.authMember.dept_list.id,
          name: this.authMember.dept_list.name,
          type: 'department',
        }]
      } else if (this.widget.options.defaultValue === 'dynamic_current_parent_dept') {
        this.memberListPaneData = [{
          id: this.authMember.parent_dept_list.id,
          name: this.authMember.parent_dept_list.name,
          type: 'department',
        }]
      } else {
        this.memberListPaneData = []
      }
    }
  },
  methods: {
    beforeUpload: function (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('不能超过2M')
      }
      return isLt2M
    },
    handleUploadChange(file, fileList) {
      console.log('handleUploadChange', file, fileList)
      // this.dataModel = fileList.map(item => {
      //   return item.response.path
      // })
    },
    handleUploadRemove(file, fileList) {
      this.fileList = fileList
    },
    handleUploadSuccess(res, file, fileList) {
      console.log('handleUploadSuccess', res, file, fileList, fileList.length)
      this.fileList = fileList
    },
  },
}
</script>
